export enum Actions {
  login,
  /**инициализация приложения */
  initApp,
  /**переключение состояния (разделы) */
  changeAppViewState,
  /**произошел навторизованный запрос */
  unauthenticatedRequest,
  /**действие с группой сниппетов */
  snippetsGroups,
  /**действие с сниппетом */
  snippet,
  /**поиск сниппетов */
  snippetSearch,
  /**сохранить конфиг CodeSection */
  codeSectionConfigSave,
  /**вывод сообщения */
  showMessage,
  /**сохранить палитру копипаста */
  copypastePaletteSave,
  /**сохранить временную палитру копипаста */
  copypasteTempPaletteSave,
  /**добавить в временную палитру копипаста */
  addToCopypasteTempPalette,
  /**хранилище ключ-значение в бд */
  namedValues,
  /**сохранить настройки в localStorage*/
  settingsLocalSave,

  /**загрузка данных задачи */
  trackerLoadItem,
  /**сохранение задачи */
  trackerSaveItem,
  /**изменение состояния задачи */
  trackerChangeItemState,
  /**изменения состояния пункта задачи */
  trackerChangeSubItemState,
  /**действия с пунктом задачи */
  trackerSubItem,
  /**применение изменений при изменении состояний пунктов задачи*/
  trackerOnChangeSubItems
}
